import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import RegistrationForm from './components/RegistrationForm';
import FeatureHighlights from './components/FeatureHighlights';
import TrustSignals from './components/TrustSignals';

const Register = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-6 md:py-8">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <Link to="/" className="flex items-center">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent/10 flex items-center justify-center">
              <Icon name="BookOpen" size={24} className="text-accent" />
            </div>
            <span className="ml-3 text-xl md:text-2xl font-bold text-foreground">CatalogFlip</span>
          </Link>
          <Link
            to="/login"
            className="text-sm md:text-base text-muted-foreground hover:text-foreground transition-colors"
          >
            Already have an account? <span className="text-accent font-medium">Sign in</span>
          </Link>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16">
          <div className="order-2 lg:order-1">
            <div className="lg:sticky lg:top-8 space-y-8 md:space-y-12">
              <div>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-3 md:mb-4">
                  Create your account
                </h1>
                <p className="text-base md:text-lg text-muted-foreground">
                  Start transforming your PDFs into interactive flipbook catalogs today
                </p>
              </div>

              <div className="hidden lg:block">
                <FeatureHighlights />
              </div>

              <div className="hidden lg:block">
                <TrustSignals />
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="bg-card border border-border rounded-xl p-6 md:p-8 lg:p-10 shadow-elevation-lg">
              <RegistrationForm />
            </div>

            <div className="lg:hidden mt-8 md:mt-12 space-y-8 md:space-y-12">
              <FeatureHighlights />
              <TrustSignals />
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-8 border-t border-border">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs md:text-sm text-muted-foreground">
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-4 md:gap-6">
              <Link to="#" className="hover:text-foreground transition-colors">
                Terms of Service
              </Link>
              <Link to="#" className="hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-foreground transition-colors">
                Cookie Policy
              </Link>
              <Link to="#" className="hover:text-foreground transition-colors">
                Contact Support
              </Link>
            </div>
            <div className="text-center sm:text-right">
              © {new Date()?.getFullYear()} CatalogFlip. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;